import { Injectable } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { SmsTimerService } from '../../../../services/sms-timer.service';
import { finalize } from 'rxjs/operators';
import { RegService } from '../../../services/reg.service';
import { BaseMode } from './base-mode';
import { RequestIdService } from '../../../services/request-id.service';
import { Router } from '@angular/router';
import { ErrorModel } from '../../../../api';
import { I18n } from '@ngx-translate/i18n-polyfill';

@Injectable({
  providedIn: 'root'
})
export class RegMode extends BaseMode {
  public title: string = this.i18n('Регистрация');
  public startUrl: string = '/auth/registration';

  constructor(
    private authService: AuthService,
    private requestIdService: RequestIdService,
    private smsTimerService: SmsTimerService,
    private regService: RegService,
    private router: Router,
    private i18n: I18n
  ) {
   super();
  }

  submit (value) {
    this.loadingSubject.next(true);

    this.regService.confirmation(value)
      .pipe(finalize(() => this.loadingSubject.next(false)))
      .subscribe(() => {
        this.router.navigate(['auth/registration-details']).then(()=>{
          this.requestIdService.reset();
        });
      }, (err: ErrorModel) => {
        this.errorSubject.next(err);
      });
  }

  repeat () {
    this.repeatLoadingSubject.next(true);

    this.regService.checkPhone(this.requestIdService.value.phoneNumber)
      .pipe(finalize(() => this.repeatLoadingSubject.next(false)))
      .subscribe(data => {
        this.smsTimerService.onSmsTimer(this.requestIdService.value.time);
      });
  }
}
